// extracted by mini-css-extract-plugin
export default {"MainContainer":"VerifyMaginLink_MainContainer__GiWzh"};